export const UNAVAILABLE_TRY_AGAIN_IN_THIRTY = 'The server is currently unavailable. Please try again in 30 seconds.';
